import { Handle, Position, type NodeProps } from "@xyflow/react";

import type { GtmFlowNodeData } from "../sequenceToFlow";

export default function GtmWaitNode({ data, selected }: NodeProps) {
  const d = data as GtmFlowNodeData;
  return (
    <div
      className={`nopan min-w-[140px] rounded-lg border bg-slate-50 px-3 py-2 shadow-sm ${
        selected ? "border-slate-500 ring-2 ring-slate-300" : "border-slate-200"
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-slate-400" />
      <div className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">Wait</div>
      <div className="text-sm font-medium text-gray-900">{d.label}</div>
      {d.subtitle ? <div className="text-xs text-gray-500">{d.subtitle}</div> : null}
      <Handle type="source" position={Position.Right} className="!bg-slate-400" />
    </div>
  );
}
